module.exports = __webpack_public_path__ + "static/assets/5bae358e3e566d38eb5bbf9c866918c9.svg";